// Builds the react-query cache key (depStr) for the All Allotments Table View
// grid. Every value the fetcher (getAllotmentPayment) filters or sorts by
// must be represented here, otherwise ServerPaginationGrid serves rows cached
// under the previous combination of these inputs.
function stableStringify(value) {
  if (value === undefined || value === null) return "";
  try {
    return JSON.stringify(value);
  } catch (e) {
    return String(value);
  }
}

export function buildAllotmentDepStr({
  subTab,
  search,
  filterBy,
  checked,
  projectStr,
  selectDates,
  version = 0,
} = {}) {
  return [
    subTab ?? "",
    search ?? "",
    filterBy ?? "",
    stableStringify(checked),
    stableStringify(projectStr),
    stableStringify(selectDates),
    version,
  ].join("|");
}
